import React, { useContext, useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import Select from "react-select";
import "./Send_Btn_Expert_Modal.css";
import Request_Send_Modal from "../../request-send-modal/Request_Send_Modal";
import {
  AllProfession,
  AllDistrict,
  AllPurchaseDate,
  AllState,
  AllTaluka,
  AllKilometer,
  AllSubProfession,
} from "../../../../features/admin/common/Slice";
import { ExpertEnquiry } from "../../../../features/admin/vendor_expert/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { Context } from "../../../../utils/context";

function Send_Btn_Expert_Modal({ expert, show, handleClose }) {
  const { userdata } = useContext(Context);
  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();

  const [showRequestSent, setShowRequestSent] = useState(false);

  const all_profession = useSelector((state) => state?.common?.all_profession);
  const states = useSelector((state) => state?.common?.all_state);
  const districts = useSelector((state) => state?.common?.all_district);
  const all_taluka = useSelector((state) => state?.common?.all_taluka);
  const all_purchase_date = useSelector(
    (state) => state?.common?.all_purchase_date,
  );
  const all_kilometer = useSelector((state) => state?.common?.all_kilometer);
  const all_sub_profession = useSelector(
    (state) => state?.common?.all_sub_professions,
  );

  const selectedState = watch("state_id");
  const selectedDistrict = watch("district_id");
  const [loading, setLoading] = useState(false);
  const constructionImageFile = watch("product_image");
  const selectedProfession = watch("profession_id");

  // useEffect(() => {
  //   dispatch(AllState());
  //   dispatch(AllProfession());
  //   dispatch(AllPurchaseDate());
  // }, [dispatch]);

  useEffect(() => {
    if (!show) return;

    dispatch(AllState());
    dispatch(AllProfession());
    dispatch(AllPurchaseDate());
    dispatch(AllKilometer());
  }, [show, dispatch]);

  // useEffect(() => {
  //   if (selectedState?.value) {
  //     dispatch(AllDistrict({ state_id: selectedState.value }));
  //   } else {
  //     setValue("district_id", null);
  //   }
  // }, [selectedState]);

  useEffect(() => {
    if (!show) return;

    if (selectedState?.value) {
      dispatch(AllDistrict({ state_id: selectedState.value }));
    } else {
      setValue("district_id", null);
    }
  }, [show, selectedState]);

  const handleStateChange = async (selectedOption) => {
    setValue("state_id", selectedOption);
    setValue("district_id", null);
    // setValue("taluqa_id", null);
    dispatch(AllDistrict({ state_id: selectedOption.value }));
  };

  const handleProfessionChange = (selectedOptions, field) => {
    field.onChange(selectedOptions);

    const selectedProfessionIds =
      selectedOptions?.map((item) => item.value) || [];

    // Current selected sub professions
    const currentSubProfessions = getValues("sub_profession_id") || [];

    // Keep only sub professions whose profession still exists
    const filteredSubProfessions = currentSubProfessions.filter((sub) =>
      selectedProfessionIds.includes(sub.profession_id),
    );

    setValue("sub_profession_id", filteredSubProfessions);

    dispatch(
      AllSubProfession({
        profession_id: selectedProfessionIds,
      }),
    );
  };
  // useEffect(() => {
  //   if (selectedDistrict?.value) {
  //     dispatch(AllTaluka({ district_id: selectedDistrict.value }));
  //   } else {
  //     setValue("taluqa_id", null);
  //   }
  // }, [selectedDistrict]);

  useEffect(() => {
    if (!show) return;

    if (selectedDistrict?.value) {
      dispatch(AllTaluka({ district_id: selectedDistrict.value }));
    } else {
      setValue("taluqa_id", null);
    }
  }, [show, selectedDistrict]);
  const [apiMessage, setApiMessage] = useState("");

  const professionOptions = [
    { value: "doctor", label: "Doctor" },
    { value: "engineer", label: "Engineer" },
  ];

  const radiusOptions = [
    { value: "10", label: "10 KM" },
    { value: "20", label: "20 KM" },
  ];

  const startTimeOptions = [
    { value: "week", label: "Within a Week" },
    { value: "month", label: "Within a Month" },
  ];

  const selectStyles = {
    control: (base) => ({
      ...base,
      border: "none",
      boxShadow: "none",
      background: "transparent",
      minHeight: "20px",
    }),
  };
  const handleRequestSendClick = () => {
    handleClose();

    setShowRequestSent(true);

    setTimeout(() => {
      setShowRequestSent(false);
    }, 3000);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("mobile_number", data.mobile);
    formData.append("purchase_date", data.purchase_date?.value);
    formData.append("kilometer", data.kilometer?.label || "");
    formData.append("state_id", data.state_id?.value);
    formData.append("district_id", data.district_id?.value);
    formData.append("taluqa_id", data.taluqa_id?.value);
    formData.append("area", data.area);
    formData.append("description", data.description);

    data.profession_id?.forEach((item) => {
      formData.append("profession_id[]", item.value);
    });

    data.sub_profession_id?.forEach((item) => {
      formData.append("sub_profession_id[]", item.value);
    });

    if (data.product_image?.length > 0) {
      formData.append("product_image", data.product_image[0]);
    }

    if (expert?.user?.id) {
      formData.append("id", expert?.user?.id);
    }

    try {
      // Await the dispatch result
      const res = await dispatch(ExpertEnquiry(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setApiMessage(res.payload?.message || "Inquiry Sent Successfully!");
        setShowRequestSent(true);

        setTimeout(() => {
          reset();
          handleClose();
          setShowRequestSent(false);
        }, 2000);
      } else {
        console.error("Inquiry failed:", res?.message);
        // Optionally, you can show an error toast here
      }
    } catch (error) {
      console.error("Error submitting inquiry:", error);
      // Optionally, show error toast here
    } finally {
      setLoading(false); // hide loader
    }
  };

  useEffect(() => {
    if (!show || !userdata) return;

    // Basic fields
    setValue("name", userdata?.name || "");
    setValue("mobile", userdata?.mobile_number || "");

    // Area
    setValue("area", userdata?.user_details?.area || "");

    // State
    if (userdata?.user_details?.state) {
      const stateObj = {
        label: userdata.user_details.state.name,
        value: userdata.user_details.state.id,
      };
      setValue("state_id", stateObj);

      // load districts
      dispatch(AllDistrict({ state_id: stateObj.value }));
    }

    // District
    if (userdata?.user_details?.district) {
      const districtObj = {
        label: userdata.user_details.district.name,
        value: userdata.user_details.district.id,
      };
      setValue("district_id", districtObj);

      // load taluka
      dispatch(AllTaluka({ district_id: districtObj.value }));
    }

    // Taluka
    if (userdata?.user_details?.taluqa) {
      setValue("taluqa_id", {
        label: userdata.user_details.taluqa.name,
        value: userdata.user_details.taluqa.id,
      });
    }

    // Profession (multi-select)
    if (userdata?.user_details?.profession) {
      setValue(
        "profession_id",
        userdata.user_details.profession.map((item) => ({
          label: item.name,
          value: item.id,
        })),
      );
    }

    // Kilometer (if exists)
    if (userdata?.user_details?.kilometer) {
      setValue("kilometer", {
        label: userdata.user_details.kilometer.name,
        value: userdata.user_details.kilometer.id,
      });
    }
  }, [show, userdata, setValue, dispatch]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="inquiry-modal"
        size="md"
      >
        <Modal.Body className="p-4">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="Scroll-modal">
              <div className="custom-input-group">
                <span className="floating-label">Full Name*</span>

                <Form.Control
                  type="text"
                  placeholder="Full Name"
                  className={classNames("custom-input", {
                    "is-invalid": errors?.name,
                  })}
                  {...register("name", {
                    required: "Full Name is required",
                  })}
                />
              </div>
              {errors?.name && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.name.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Mobile Number*</span>

                <Form.Control
                  type="text"
                  placeholder="4587523254"
                  className={classNames("custom-input", {
                    "is-invalid": errors?.mobile,
                  })}
                  {...register("mobile", {
                    required: "Mobile number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Mobile number must be exactly 10 digits",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
              </div>
              {errors?.mobile && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.mobile.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Profession*</span>
                {/* <Controller
                  name="profession_id"
                  control={control}
                  rules={{ required: "Profession is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isMulti
                      options={all_profession}
                      styles={selectStyles}
                      classNamePrefix="react-select"
                      placeholder="Select Profession"
                      isSearchable={false}
                      value={field.value || []}
                      onChange={(selected) => field.onChange(selected)}
                    />
                  )}
                /> */}
                <Controller
                  name="profession_id"
                  control={control}
                  rules={{ required: "Profession is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isMulti
                      options={all_profession}
                      value={field.value || []}
                      onChange={(selected) =>
                        handleProfessionChange(selected, field)
                      }
                    />
                  )}
                />
              </div>
              {errors?.profession_id && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.profession_id.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Sub Profession Category*</span>

                <Controller
                  name="sub_profession_id"
                  control={control}
                  rules={{ required: "Sub Profession is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isMulti
                      options={all_sub_profession}
                      value={field.value || []}
                      onInputChange={(name) => {
                        if (selectedProfession?.length) {
                          dispatch(
                            AllSubProfession({
                              profession_id: selectedProfession.map(
                                (item) => item.value,
                              ),
                              name,
                            }),
                          );
                        }
                      }}
                      onChange={(selected) => field.onChange(selected)}
                    />
                  )}
                />
              </div>

              {errors?.sub_profession_id && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.sub_profession_id.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Kilometer*</span>

                <Controller
                  name="kilometer"
                  control={control}
                  rules={{ required: "Kilometer is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={all_kilometer}
                      styles={selectStyles}
                      classNamePrefix="react-select"
                      placeholder=""
                      isSearchable={false}
                      value={field.value || []}
                      onChange={(selected) => field.onChange(selected)}
                    />
                  )}
                />
              </div>
              {errors?.kilometer && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.kilometer.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">State*</span>

                <Controller
                  name="state_id"
                  control={control}
                  rules={{ required: "State is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={states}
                      styles={selectStyles}
                      classNamePrefix="react-select"
                      placeholder="Select State"
                      onChange={handleStateChange}
                      onInputChange={(val) => {
                        dispatch(AllState(val));
                      }}
                    />
                  )}
                />
              </div>
              {errors?.state_id && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.state_id.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">District*</span>
                <Controller
                  name="district_id"
                  control={control}
                  rules={{ required: "District is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={districts}
                      styles={selectStyles}
                      classNamePrefix="react-select"
                      placeholder=" Select District"
                      isDisabled={!selectedState}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption);
                      }}
                    />
                  )}
                />
              </div>
              {errors?.district_id && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.district_id.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Taluka*</span>
                <Controller
                  name="taluqa_id"
                  control={control}
                  rules={{ required: "Taluka is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={all_taluka}
                      styles={selectStyles}
                      classNamePrefix="react-select"
                      placeholder=" Select Taluka"
                      isDisabled={!selectedDistrict}
                      onChange={(selectedOption) =>
                        field.onChange(selectedOption)
                      }
                    />
                  )}
                />
              </div>
              {errors?.taluqa_id && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.taluqa_id.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Area*</span>

                <Form.Control
                  type="text"
                  placeholder="Enter Area"
                  className={classNames("custom-input", {
                    "is-invalid": errors?.area,
                  })}
                  {...register("area", {
                    required: "Area is required",
                    minLength: {
                      value: 2,
                      message: "Area must be at least 2 characters",
                    },
                  })}
                />
              </div>
              {errors?.area && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.area.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Work Start Time</span>
                <Controller
                  name="purchase_date"
                  control={control}
                  rules={{ required: "Purchase Date is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      placeholder="Select Start Time"
                      options={all_purchase_date}
                      onInputChange={(val) => {
                        dispatch(AllPurchaseDate(val));
                      }}
                    />
                  )}
                />
              </div>
              {errors?.purchase_date && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.purchase_date.message}
                </span>
              )}

              <div className="custom-input-group upload-section">
                <span className="floating-label">Upload Product Image</span>

                <Form.Control
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  className={classNames("custom-file-input", {
                    "is-invalid": errors?.product_image,
                  })}
                  {...register("product_image", {
                    required: "Material Image is required",
                    validate: (value) => {
                      if (!value || value.length === 0)
                        return "Material Image is required";

                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                      ];

                      if (!allowedTypes.includes(value[0].type)) {
                        return "Only JPG, JPEG, PNG files allowed";
                      }

                      return true;
                    },
                  })}
                />
              </div>
              {errors?.product_image && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.product_image.message}
                </span>
              )}
              {constructionImageFile && constructionImageFile.length > 0 && (
                <div className="image-preview-container mt-2">
                  <img
                    src={URL.createObjectURL(constructionImageFile[0])}
                    alt="Construction Preview"
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                    }}
                  />
                </div>
              )}

              <div className="custom-input-group gap-div">
                <span className="floating-label">Description*</span>

                <Form.Control
                  type="textarea"
                  placeholder="Description"
                  className={classNames("custom-input", {
                    "is-invalid": errors?.description,
                  })}
                  {...register("description", {
                    required: "Description is required",
                    minLength: {
                      value: 2,
                      message: "Description must be at least 2 characters",
                    },
                  })}
                />
              </div>
              {errors?.description && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.description.message}
                </span>
              )}
            </div>

            <div className="text-center mt-4">
              {/* <Button type="submit" className="submit-inquiry-pill">
                Send Inquiry
              </Button> */}
              <Button
                type="submit"
                className="submit-inquiry-pill"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Inquiry"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Request_Send_Modal
        showRequestSent={showRequestSent}
        message={apiMessage} // pass message from response
        handleRequestSendClose={() => setShowRequestSent(false)}
      />
    </>
  );
}

export default Send_Btn_Expert_Modal;
